import { api } from '@/services/api'

export interface ClientWithEmails {
  id: string
  nom: string
  email: string
  emails: string[]
}

export async function fetchClientsWithEmails(): Promise<ClientWithEmails[]> {
  const response = await api.get<{
    data: Array<{ id: number; nom: string; emails?: string[] }>
    count: number
  }>('/users/clients')

  return (response.data.data || []).map((client) => {
    const emails = (client.emails || []).filter(Boolean)
    return {
      id: String(client.id),
      nom: client.nom,
      email: emails[0] || '',
      emails,
    }
  })
}

export function formatClientLabel(nom: string, emails: string[]): string {
  if (emails.length === 0) return nom
  if (emails.length <= 2) return `${nom} - ${emails.join(', ')}`
  return `${nom} - ${emails.slice(0, 2).join(', ')} (+${emails.length - 2})`
}
